import * as Text      from '../../../../components/form/text/main';
import * as Email     from '../../../../components/form/email/main';
import * as Checkbox  from '../../../../components/form/checkbox/main';
import * as Form      from '../../../../components/form/from/main';
import * as ReCaptcha from '../../../../components/form/recaptcha/main';

// Init
Form.init('user-register-form');
const texts      = Array.from(document.getElementsByClassName('text-widget'))      as Text.Elm[];
const emails     = Array.from(document.getElementsByClassName('email-widget'))     as Email.Elm[];
const reCapt     = Array.from(document.getElementsByClassName('recaptcha-widget')) as ReCaptcha.Elm[];
const checkboxes = Array.from(document.getElementsByClassName('checkbox-widget'))  as Checkbox.Elm[];

const allElms = 
  (texts as any[])
  .concat(emails)
  .concat(reCapt);

texts     .forEach(elm => Text.init(elm));
emails    .forEach(elm => Email.init(elm));
reCapt    .forEach(elm => ReCaptcha.init(elm));
checkboxes.forEach(elm => Checkbox.init(elm));

// Submit
const form     = document.getElementById('user-register-form') as HTMLFormElement;
const button   = document.getElementById('contact-submit')     as HTMLButtonElement;

button.addEventListener('click', event => {
  event.preventDefault();

  allElms.forEach(elm => elm.xIsValid());
  let isValid = allElms.reduce( (allValid, elm) => allValid && elm.xIsValid(), true);

  if (isValid) {
    form.submit();
  }
})
